class APIFailException extends Error {
  constructor(message) {
    super(message);
    this.name = "APIFailException";
  }
}

export default APIFailException;
